/**
 * The update prompt.
 *
 * `registerType: 'prompt'` in vite.config.ts means a new worker installs and
 * then waits. This hook exposes that wait so the UI can offer a "new version"
 * bar, and applies it only when the user says so. See the reasoning there: a
 * silent reload beside a whelping box discards whatever was half-typed.
 */
import { useRegisterSW } from 'virtual:pwa-register/react';

export const useServiceWorker = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(url, registration) {
      // An installed PWA can run for weeks without a full page load, and the
      // browser only checks for a new worker on navigation. Without this, a
      // fix ships and the people who installed the app never see it.
      if (registration === undefined) return;
      setInterval(() => void registration.update(), 60 * 60 * 1000);
      void url;
    },
  });

  return {
    needRefresh,
    offlineReady,
    dismiss: () => {
      setNeedRefresh(false);
      setOfflineReady(false);
    },
    update: () => void updateServiceWorker(true),
  };
};
